import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class FamiliaService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerFamiliaxRubro(rutEmpresa, codigoRubro, callback) {
        this.gqlclient.query({
            query: gql `
        query($empresa_rut: Decimal, $rubro_codigo: Decimal) {
          familia{
            obtenerFamiliaxRubro(
              empresa_rut: $empresa_rut,
              rubro_codigo: $rubro_codigo
            ){
              respuesta{
                registros{
                  codigo
                  nombre
                  empresa_rut
                  rubro_codigo
                  activo
                }
              }
            }
          }
        }
        `,
            variables: {
                empresa_rut: Number(rutEmpresa),
                rubro_codigo: codigoRubro
            },
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.familia.obtenerFamiliaxRubro;
            callback({ mensajes, respuesta });
        });
    }
    obtenerFamiliaxRubroReporteVenta(rutEmpresa, codigoRubro, callback) {
        this.gqlclient.query({
            query: gql `
        query($empresa_rut: Decimal, $rubro_codigo: Decimal) {
          familia{
            obtenerFamiliaxRubroReporteVenta(
              empresa_rut: $empresa_rut,
              rubro_codigo: $rubro_codigo
            ){
              respuesta{
                registros{
                  codigo
                  nombre
                  empresa_rut
                  rubro_codigo
                  activo
                }
              }
            }
          }
        }
        `,
            variables: {
                empresa_rut: Number(rutEmpresa),
                rubro_codigo: codigoRubro
            },
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.familia.obtenerFamiliaxRubroReporteVenta;
            callback({ mensajes, respuesta });
        });
    }
    obtenerSegunFiltro(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: familiaInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          familia {
            obtenerSegunFiltro(filtro: {exacto: $entidad}, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                registros {
                  codigo
                  nombre
                  empresa_rut
                  rubro_codigo
                  rubro_nombre
                  activo
                }
                totalPaginas
                totalRegistros
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.familia.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
    obtenerTodos(callback) {
        this.gqlclient.query({
            query: gql `
        {
          familia {
            obtenerTodos {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                registros {
                  codigo
                  nombre
                  empresa_rut
                  rubro_codigo
                  activo
                }
              }
            }
          }
        }
        `,
            variables: {},
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.familia.obtenerTodos;
            callback({ mensajes, respuesta });
        });
    }
    guardar(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        mutation ($entidad:familiaInputType) {
          familia {
            guardar(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                nombre
                rubro_codigo
                activo
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.familia.guardar;
            callback({ mensajes, respuesta });
        });
    }
    cambiaEstado(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        mutation ($entidad: familiaInputType) {
          familia {
            cambiaEstado(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                activo
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.familia.cambiaEstado;
            callback({ mensajes, respuesta });
        });
    }
    obtenerTodasFamilias(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: familiaInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          familia {
            obtenerTodasFamilias(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                registros {
                  codigo
                  nombre
                  empresa_rut
                  rubro_codigo
                  rubro_nombre
                  activo
                }
                totalPaginas
                totalRegistros
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.familia.obtenerTodasFamilias;
            callback({ mensajes, respuesta });
        });
    }
    obtenerFamiliasSolas(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: familiaInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          familia {
            obtenerFamiliasSolas(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                registros {
                  codigo
                  nombre
                  empresa_rut
                  rubro_codigo
                  activo
                }
                totalPaginas
                totalRegistros
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.familia.obtenerFamiliasSolas;
            callback({ mensajes, respuesta });
        });
    }
}
FamiliaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FamiliaService_Factory() { return new FamiliaService(i0.ɵɵinject(i1.GraphQLClient)); }, token: FamiliaService, providedIn: "root" });
